<template>
  <form id="create_program_form">
    <div class="card card-custom gutter-b">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label">افزودن برنامه‌</h3>
        </div>
      </div>
      <div class="card-body">
        <div class="form-group">
          <label>عنوان</label>
          <input
            type="text"
            name="name"
            v-model="form.name"
            class="form-control"
          />
        </div>
        <div class="form-group">
          <label>پُستر (اختیاری)</label>
          <div></div>
          <div class="custom-file">
            <input
              type="file"
              class="custom-file-input"
              id="poster_file"
              ref="poster"
              @change="fileChanged"
              accept="image/*"
            />
            <label class="custom-file-label" for="poster_file"></label>
          </div>
        </div>
        <div class="form-group">
          <label>پلن</label>
          <div class="radio-inline">
            <label
              v-for="(plan, key) in programPlans"
              :key="`plan-${key}`"
              class="radio"
            >
              <input
                type="radio"
                name="plan"
                :value="key"
                v-model="form.plan"
              />
              <span></span>
              {{ plan }}
            </label>
          </div>
          <span class="form-text text-muted">{{ programPlanInfo }}</span>
        </div>
        <div class="form-group">
          <label>ورودی</label>
          <div class="radio-inline">
            <label
              v-for="(type, key) in programTypes"
              :key="`type-${key}`"
              class="radio"
            >
              <input
                type="radio"
                name="type"
                :value="key"
                v-model="form.type"
              />
              <span></span>
              {{ type }}
            </label>
          </div>
          <span class="form-text text-muted">{{ programTypeInfo }}</span>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import { STORE_PROGRAM } from "@/core/services/store/programs.module";
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import { mapGetters } from "vuex";

export default {
  name: "programs-create",
  props: ["id"],
  data() {
    return {
      isCompany: this.$route.name.startsWith("company"),
      isAdmin: this.$route.name.startsWith("admin"),
      form: {
        name: "",
        type: "1",
        plan: "3"
      },
      progressMode: true,
      filePath: ""
    };
  },
  mounted() {
    this.setBreadcrumbs();
    this.setActions();

    this.eventHub.$on("save-program-event", this.save);

    let $this = this;

    this.fv = formValidation(document.getElementById("create_program_form"), {
      fields: {
        name: {
          validators: {
            notEmpty: {
              message: "نام صحیح نیست"
            },
            stringLength: {
              min: 2,
              max: 128,
              message: "نام صحیح نیست"
            }
          }
        },
        file_address: {
          validators: {
            callback: {
              message: "مسیر فایل صحیح نیست",
              callback: function(input) {
                if ($this.form.type === "2") {
                  return input.value !== "";
                }
                return true;
              }
            }
          }
        },
        link_address: {
          validators: {
            callback: {
              message: "لینک صحیح نیست",
              callback: function(input) {
                if ($this.form.type === "3") {
                  return input.value !== "";
                }
                return true;
              }
            }
          }
        }
      },
      plugins: {
        trigger: new Trigger(),
        bootstrap: new Bootstrap()
      }
    });
  },
  beforeDestroy() {
    this.eventHub.$off("save-program-event");
    document.getElementById("save-program-btn").disabled = false;
  },
  computed: {
    ...mapGetters([
      "currentUserProperty",
      "program",
      "programPlans",
      "programTypes"
    ]),
    archive_enabled() {
      return this.form.plan === "1";
    },
    programPlanInfo() {
      if (this.form.plan === "1") {
        return "حداکثر ۷ دقیقه";
      } else if (this.form.plan === "2") {
        return "دارای  لوگو";
      } else {
        return "بدون تبلیغات و لوگو و محدودیت زمانی";
      }
    },
    programTypeInfo() {
      if (this.form.type === "1") {
        return "ارسال با نرم‌افزار(obs , ...)";
      } else if (this.form.type === "2") {
        return "در مرحله بعد فایل های خود را آپلود و یا لینک آن را به ترتیب نوبت پخش وارد کنید.";
      } else {
        return "";
      }
    },
    progressBar() {
      return this.$store.state.files.fileManagerProgress;
    },
    uploading() {
      return this.$store.state.files.fileManagerProgress > 0;
    }
  },
  methods: {
    setBreadcrumbs() {
      let programsRouteName = "programs-index";

      let items = [];
      if (this.isCompany) {
        programsRouteName = "company-programs-index";

        items.push({
          title: this.currentUserProperty.title ?? "شرکت",
          route: { name: "company-dashboard" }
        });
      }

      items.push({ title: "برنامه‌‌ها", route: { name: programsRouteName } });
      items.push({ title: "افزودن" });

      this.$store.dispatch(SET_BREADCRUMB, items);
    },
    setActions() {
      let programsRouteName = "programs-index";

      if (this.isCompany) {
        programsRouteName = "company-programs-index";
      }

      this.$store.dispatch(SET_ACTIONS, {
        buttons: [
          {
            name: "ذخیره",
            event: "save-program-event",
            class: "btn-primary",
            id: "save-program-btn"
          }
        ],
        links: [
          {
            name: "بازگشت",
            to: { name: programsRouteName }
          }
        ]
      });
    },
    fileChanged(e) {
      if (e.target.files && e.target.files[0]) {
        e.target.nextElementSibling.innerHTML = e.target.files[0].name;
        e.target.nextElementSibling.classList.add("selected");
      } else {
        e.target.nextElementSibling.innerHTML = "";
        e.target.nextElementSibling.classList.remove("selected");
      }
    },
    save() {
      let programShowRoute =
        this.isCompany === false ? "programs-show" : "company-programs-show";

      if (this.isAdmin) {
        programShowRoute = "admin-programs-show";
      }

      this.fv.validate().then(status => {
        if (status === "Valid") {
          let submitBtn = document.getElementById("save-program-btn");
          this.disableBtn(submitBtn);

          let formData = new FormData();

          if (this.isCompany || this.isAdmin) {
            formData.append("user", this.$route.params.id);
          }

          formData.append("name", this.form.name);
          formData.append("type", this.form.type);
          formData.append("plan", this.form.plan);

          if (this.$refs.poster.files && this.$refs.poster.files[0]) {
            formData.append("poster", this.$refs.poster.files[0]);
          }

          this.$store
            .dispatch(STORE_PROGRAM, formData)
            .then(program => {
              this.enableBtn(submitBtn);
              if (this.form.type === "2") {
                this.$router.push({
                  name: "programs-files",
                  params: { id: program.id }
                });
              } else {
                this.$router.push({
                  name: programShowRoute,
                  params: { id: program.id }
                });
              }
            })
            .catch(() => {
              this.enableBtn(submitBtn);
            });
        } else if (status === "Invalid") {
          this.showError("لطفا فرم را به شکل صحیح کامل کنید");
        }
      });
    }
  }
};
</script>
